var cnzz_protocol = (("https:" == document.location.protocol) ? "https://" : "http://");
document.write(unescape(
	"%3Cspan id='cnzz_stat_icon_1280650682'%3E%3C/span%3E%3Cscript src='https://s4.cnzz.com/z_stat.php%3Fid%3D1280650682%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"
	));
